// extracted by mini-css-extract-plugin
module.exports = {"root":"Package_root__zfTu9","hasAnimation":"Package_hasAnimation__Y2RRV","pathAnimation":"Package_pathAnimation__a0P0_","infiniteAnimation":"Package_infiniteAnimation__jgfqP"};